"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidUrl = void 0;
// eslint-disable-next-line import/prefer-default-export
const isValidUrl = (url) => {
    const urlPattern = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm;
    return !!url.match(urlPattern);
};
exports.isValidUrl = isValidUrl;
